import * as home from './home.api';
export default {
    home,
}
